<template>
    <div :class="$style.container">
        <AnimatedPlaceholder :class="$style.circle" />
        <div :class="$style.verticalGroup">
            <AnimatedPlaceholder :class="$style.sausageTop" />
            <AnimatedPlaceholder :class="$style.sausageBottom" />
        </div>
        <AnimatedPlaceholder :class="$style.button" />
    </div>
</template>
<script setup lang="ts">
import AnimatedPlaceholder from '@/components_new/AnimatedPlaceholder/AnimatedPlaceholder.vue'
</script>
<style module>
.container {
    display: flex;
    flex-direction: row;
    align-items: center;
    text-align: center;
    border-radius: 26px;
    gap: 8px;
    height: 48px;
    justify-content: space-between;
}

.circle {
    width: 48px;
    height: 48px;
    border-radius: 50%;
}

.button {
    width: 92px;
    height: 48px;
    border-radius: 1000px;
}

.verticalGroup {
    display: flex;
    flex-direction: column;
    flex-grow: 3;
    gap: 4px;
}

.sausageTop {
    height: 20px;
    border-radius: 6px;
    width: 60px;
}

.sausageBottom {
    height: 14px;
    border-radius: 6px;
}

@keyframes blink {
    0% {
        background-color: var(--white-08);
    }

    38% {
        background-color: var(--white-16);
    }

    50% {
        background-color: var(--white-16);
    }

    88% {
        background-color: var(--white-08);
    }

    100% {
        background-color: var(--white-08);
    }
}
</style>
